import { Config } from '@/types/config';

export function insertTrackerIframe ({ appConfig, callback }: {
    appConfig: Config;
    callback: (this: HTMLIFrameElement, ev: Event) => any;
}) {
    let iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'odr-tracker');
    iframe.setAttribute('style', 'display: none !important');
    iframe.setAttribute('src', appConfig.staticUrl + '/ga.html');
    iframe.addEventListener('load', callback);
    document.body.appendChild(iframe);
}
